import { createSelector } from "reselect";

import { type AppStore } from "../../../index";

const getUser = (state: AppStore) => state.user.profile;

export const getUserRole = createSelector([getUser], (user) => {
  return user?.role || null;
});
